<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import DatePicker from 'dashboard/components/carBooking/DatePicker.vue';
import TimePicker from 'dashboard/components/carBooking/TimePicker.vue';
import FormField from './FormField.vue';

const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
  error: { type: String, default: '' },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const date = ref('');
const time = ref('');

watch(
  () => props.modelValue,
  value => {
    const [datePart = '', timePart = ''] = (value || '').split('T');
    date.value = datePart;
    // Automated rows carry seconds and a zone (`10:00:00Z`); TimePicker only
    // understands `HH:mm`. The stored value is left alone until it is edited.
    time.value = (/^\d{2}:\d{2}/.exec(timePart) || [''])[0];
  },
  { immediate: true }
);

const emitValue = () => {
  emit(
    'update:modelValue',
    date.value && time.value ? `${date.value}T${time.value}` : ''
  );
};

const onDate = value => {
  date.value = value;
  emitValue();
};

const onTime = value => {
  time.value = value;
  emitValue();
};
</script>

<template>
  <FormField :label="label" :error="error">
    <div class="grid grid-cols-2 gap-2">
      <DatePicker
        :model-value="date"
        :placeholder="t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.FORM.DATE')"
        @update:model-value="onDate"
      />
      <TimePicker
        :model-value="time"
        :placeholder="t('CONTACTS_LAYOUT.SIDEBAR.BOOKINGS.FORM.TIME')"
        @update:model-value="onTime"
      />
    </div>
  </FormField>
</template>
